export default __webpack_public_path__ + "static/TextGroup-a1e7fa39cf71385caf48c161d7c04872.mp4";